// Module
var code = `<div class="accordion amortization-accordion"
     ng-if="\$ctrl.installments">
  <table class="table">
    <thead>
    <tr>
      <th>No</th>
      <th>Pledge date</th>
      <th ng-if="!\$ctrl.simulationMode">Status</th>
      <th ng-if="!\$ctrl.simulationMode">Date paid</th>
      <th>Pledge amount</th>
      <th ng-if="!\$ctrl.simulationMode">Pledge balance</th>
      <th ng-if="\$ctrl.simulationMode">Total deposit after</th>
      <th ng-if="!\$ctrl.simulationMode">Total amount paid</th>
    </tr>
    </thead>
    <tbody class="tbody">
    <tr
      ng-repeat-start="row in \$ctrl.installments track by \$index"
      class="table__row--clickable"
      ng-click="\$ctrl.showPledgeEffectiveDueDate(row.lineNumber, \$event)"
    >
      <td>{{row.lineNumber}}</td>
      <td>{{row.dueDate | prettyDate }}</td>
      <td ng-class="\$ctrl.getColor(row.status)" ng-if="!\$ctrl.simulationMode">{{row.status}}</td>
      <td ng-if="!\$ctrl.simulationMode">{{row.datePaid | prettyDate }}</td>
      <td>{{row.amount | nxCurrency:'dashOnZero'}}</td>
      <td ng-if="!\$ctrl.simulationMode">{{row.balance | nxCurrency:'dashOnZero'}}</td>
      <td ng-if="\$ctrl.simulationMode">{{row.totalDepositAfter | nxCurrency:'dashOnZero'}}</td>
      <td ng-if="!\$ctrl.simulationMode">{{row.totalAmountPaid | nxCurrency:'dashOnZero'}}</td>
    </tr>
    <tr ng-repeat-end class="table__row--not-hoverable">
      <td colspan="100%">
        <div class="toggleable-panel-wrapper"
             ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedPledgeLineNumber === row.lineNumber}">
          <inline-panel on-hide="\$ctrl.hidePledgeEffectiveDueDate()">
            <div class="inline-panel__container">
              <label class="inline-panel__label">Pledge date with grace period:</label>
              <p class="inline-panel__value">{{\$ctrl.getEffectiveDueDate(row.dueDate) | prettyDate }}</p>
            </div>
          </inline-panel>
        </div>
      </td>
    </tr>
    <tr>
      <td>Total:</td>
      <td></td>
      <td ng-if="!\$ctrl.simulationMode"></td>
      <td ng-if="!\$ctrl.simulationMode"></td>
      <td>{{\$ctrl.getTotalPledgeAmount() | nxCurrency:'dashOnZero'}}</td>
      <td ng-if="!\$ctrl.simulationMode">{{\$ctrl.getTotalBalance() | nxCurrency:'dashOnZero'}}</td>
      <td></td>
    </tr>
    </tbody>
  </table>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/pledge/pledge-installment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;